import { QueryKey, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

export const useInvalidateQueriesOnChange = (value: unknown, queryKey: QueryKey) => {
  const queryClient = useQueryClient();
  const previousValueRef = useRef(value);

  useEffect(() => {
    if (Object.is(previousValueRef.current, value)) {
      return;
    }
    previousValueRef.current = value;

    const refresh = async () => {
      await queryClient.cancelQueries({ queryKey });
      await queryClient.invalidateQueries({ queryKey });
    };

    void refresh();
  }, [queryClient, queryKey, value]);
};
